// ─────────────────────────────────────────────
// logger.ts
// Centralised guard wrapper around sendFrontendError.
// Import logError from HERE — not sendFrontendError directly.
// This keeps the recursion guard and 4xx filter in one place,
// reachable by both app.ts and errorHandlers.ts without circular deps.
// ─────────────────────────────────────────────

import sendFrontendError, { FrontendErrorPayload } from "./errorTracker";

export const logError = (payload: FrontendErrorPayload): void => {
    // Prevent infinite recursion if the error endpoint itself fails
    if (payload.url?.includes("/frontend-error")) return;

    // Skip 4xx client errors except 419 — reduce noise in ERP
    if (
        payload.status &&
        payload.status >= 400 &&
        payload.status < 500 &&
        payload.status !== 419
    ) {
        return;
    }

    sendFrontendError(payload);
};
